import React, { PureComponent } from 'react';
import { View } from '@dbk/ui-react-utils';
import ReactModal from 'react-modal';
import { createContainer } from '@dbk-legacy/muster/react';
import { CallBackRequest, WrongChoiceIncorrect, Transactions, TradingPlatform } from '@dbk/ui-icons';
import { Gear } from '../../../../../src/components/common/icons';
import '../../../../../src/screens/menu-modal/menu-modal.css';
import { iconStyle } from '../../../../../src/screens/menu-modal/menu-modal.style.js';
import { RmCallBack } from '../../../../../src/screens/modal-content';
import { ROUTES } from '../../../../../src/constants'
import Guid from '../../../../../src/utils/guid';
import { PALETTE } from '../../constants';
class MenuModal extends PureComponent {
  constructor() {
    super();
    this.state = {
      modalIsOpen: true,
      isRmCallBackModalActive: false,
      modalContentType: '',
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handlePress = this.handlePress.bind(this);
    this.renderMenuContent = this.renderMenuContent.bind(this);
  }

  hideModal = () => {
    this.setState(() => ({
      isRmCallBackModalActive: false,
    }));
    this.closeModal();
  };

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  closeModal() {
    this.props.onChange();
  }

  modalContent() {
    switch (this.state.modalContentType) {
      case 'rmcallback':
        return <RmCallBack onChange={() => this.closeModal()} />;
      default:
        return <View />;
    }
  }

  renderMenuContent() {
    const {
      i18n: { messages },
      auth: { entitlement, vascoActivated, entitlements: { trading } },
    } = this.props;
    return (
      <div className="menu-box">
        {vascoActivated && trading && <div className="menu-Item pointer"
          onClick={() => this.handlePress('trading')} >
          <TradingPlatform width={iconStyle.width} height={iconStyle.height} color={iconStyle.color} />
          <div className="min-content">{messages['app.trade']}</div>
        </div>}
        {/* Commenting this as a part of Jira ID WMCE-326 implementation
        (isPaymentCheck && vascoActivated) ?
          <div onClick={() => this.handlePress('payments')}
            className="menu-Item pointer menu-border-left">
            <Transactions width={iconStyle.width} height={iconStyle.height} color={iconStyle.color} />
            <div>{messages['app.common.pageHeader.Payments']}</div>
          </div> :
          <div onClick={() => console.log('disabled')}
            className="menu-Item pointer menu-border-left disabled">
            <Transactions width={iconStyle.width} height={iconStyle.height} color={iconStyle.color} />
            <div>{messages['app.common.pageHeader.Payments']}</div>
          </div>
*/
        }
        <div className="menu-Item pointer menu-border-left"
          id="mainSetting_landingPage"
          onClick={() => this.handlePress('settings')} >
          <Gear width={iconStyle.width} height={iconStyle.height} color={iconStyle.color} />
          <div>{messages['app.settings']}</div>
        </div>

        {entitlement.rmcallback &&
          <div className="menu-Item pointer menu-border-left" onClick={() => this.handlePress('rmcallback')}>
            <CallBackRequest width={iconStyle.width} height={iconStyle.height} color={iconStyle.color} />
            <div>{messages['app.rmCallback']}</div>
          </div>
        }
      </div>
    );
  }

  handlePress(selectedMenu) {
    const {
      changePage,
      rsaChangePage,
      rsa: { rsaAuthorised },
      ui: {
        title,
      },
      callback,
      i18n: { messages },
      payments: { setFilterFlag },
    } = this.props;
    if (selectedMenu === 'rmcallback') {
      this.closeModal();
      this.props.onChange();
      const currentScreen = title;
      callback.setPage(currentScreen);
      if (callback.screen != "rmcallback")
        rsaChangePage('/rmcallback/' + messages[currentScreen]);
    }
    if (selectedMenu === 'settings') {
      this.closeModal();
      this.props.onChange();
      changePage('/profile');
    }
    if (selectedMenu === 'payments') {
      this.props.onChange();
      setFilterFlag(false);
      changePage('/payments');
      this.setState({
        modalIsOpen: false,
      });
    }
    if (selectedMenu === 'trading') {
      this.closeModal();
      this.props.onChange();
      this.props.setInitialPathGuid(Guid())
      this.props.setInitialPath(ROUTES.TRADE.OVERVIEW)
      if (this.props.ui.history.currentLocation.pathname !== ROUTES.TRADE.LIBRARY)
        changePage(ROUTES.TRADE.LIBRARY);
    }
  }

  render() {
    const {
      screen,
      marque: { loginDissmiss },
      auth: { entitlement },
    } = this.props;

    const { width } = screen;
    const customStyles = {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 11,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
      },
      content: {
        position: 'absolute',
        top: loginDissmiss ? '49px' : '90px',
        left: width > 570 ? 'auto' : 40,
        right: entitlement.notification ? '142px' : '100px',
        bottom: 'auto',
        padding: 0,
        border: 0,

        backgroundColor: 'transparent',
        overflow: 'visible',
      },
    };
    return (
      <div>
        {this.state.modalIsOpen && (
          <ReactModal
            isOpen={this.state.modalIsOpen}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModal}
            contentLabel="Modal"
            style={customStyles}
            testID="blur-modal"
            ariaHideApp={false}
          >
            <div className="db-modal">
              <div className="noti-modal">
                <div
                  className={'cross-icon-position pointer'}
                  id="icon_menu_close_menuModal_test"
                  onClick={() => this.closeModal()}
                >
                  <WrongChoiceIncorrect
                    width={24}
                    height={24}
                    color={PALETTE.primaryActive}
                  />
                </div>
                <div className="noti-modal-before" style={{ 'border-bottom-color' : PALETTE.dbModalBackground}}/>
                {this.renderMenuContent()}
              </div>
            </div>
          </ReactModal>
        )}
        {/* {this.state.isRmCallBackModalActive && (
          <Modal
            {...this.props}
            isActive={this.state.isRmCallBackModalActive}
            onClose={this.hideModal}
            content={this.modalContent()}
          />
        )} */}
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    setInitialPath: { $set: 'ui.component.initialPath' },
    setInitialPathGuid: { $set: 'ui.component.initialPathGuid' },
    screen: {
      height: true,
      width: true,
      isSmall: true,
    },
    i18n: {
      messages: true,
    },
    changePage: { $call: 'ui.history.push' },
    rsaChangePage: { $call: 'rsa.changePage' },
    rsa: { rsaAuthorised: true },
    marque: {
      loginDissmiss: true,
    },
    auth: {
      entitlement: true,
      vascoActivated: true,
      entitlements: {
        trading: true,
      }
    },
    ui: {
      title: true,
      customtitle: true,
      history: {
        currentLocation: {
          pathname: true
        },
      },
    },
    callback: {
      screen: true,
      setScreen: { $call: 'setScreen' },
      setPage: { $set: 'pagename' },
    },
    payments: { setFilterFlag: { $set: 'filterFlag' } },
  },
})(MenuModal);
